<template>
  <div>
    <v-container fluid>
      <v-card
        border
        tile
      >
        <v-card-title
          class="fs-28"
          role="heading"
        >
          {{ $bct('Billing Center') }}
        </v-card-title>

        <v-card-text class="px-0 py-0">
          <v-tabs
            v-model="tab"
            @update:model-value="tabChange"
            bg-color="surface"
            grow
          >
            <v-tab value="invoices">
              {{ $bct('Invoices') }}
            </v-tab>

            <v-tab value="statements">
              {{ $bct('Statements') }}
            </v-tab>
          </v-tabs>

          <v-window
            v-model="tab"
            class="border-t"
          >
            <v-window-item value="invoices">
              <BillingInvoiceIndex />
            </v-window-item>

            <v-window-item value="statements">
              <BillingStatementIndex
                :can-open-invoices="false"
                :statements-api="Api.manager.billingStatements"
              />
            </v-window-item>
          </v-window>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';

import BillingInvoiceIndex from '@/manager/components/BillingInvoiceIndex.vue';
import BillingStatementIndex from '@/shared/components/billing/BillingStatementIndex.vue';
import useApi from '@/shared/composables/useApi';
import useRouterHelper from '@/shared/composables/useRouterHelper';

const $bct = inject('translator');

const route = useRoute();
const { api: Api } = useApi();
const { updateQuery } = useRouterHelper();

const providers = ref([]);
const tab = ref('statements');

async function load() {
  if (route.query.tab === 'invoices') await tabChange('invoices');

  await loadProviders();
}

async function loadProviders() {
  const response = await Api.manager.provider.index();
  providers.value = response.data;
}

async function tabChange(newValue) {
  tab.value = newValue;
  await updateQuery({ tab: tab.value });
}

onMounted(load);
</script>
